import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './imgDialog.css'; // Make sure to create a corresponding CSS file

const ImgDialog = ({ imageUrl, onClose }) => {
    return (
        <div className="ImgDialog-modal">
            <div className="modal-content">
                <button className="close-button" onClick={onClose}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
                {/* <span className="close" onClick={onClose}>&times;</span> */}
                <img src={imageUrl} alt="Cropped" />
            </div>
        </div>
    );
};

export default ImgDialog;